import React from 'react'
import { PaymentPillProps } from '.'
import { PaymentPillContainer, PaymentTitle } from './PaymentPill.styled'
import SVG from 'react-inlinesvg'
import PartialIcon from 'assets/icons/partial-icon.svg'
import PaidIcon from 'assets/icons/fully-icon.svg'
import UnpaidIcon from 'assets/icons/unpaid-icon.svg'

const PaymentPill = ({ type }: PaymentPillProps) => {
  return (
    <PaymentPillContainer type={type}>
      {type === 'partial' && (
        <SVG src={PartialIcon} style={{ marginLeft: 16 }} />
      )}
      {type === 'unpaid' && <SVG src={UnpaidIcon} style={{ marginLeft: 16 }} />}
      {type === 'paid' && <SVG src={PaidIcon} style={{ marginLeft: 16 }} />}
      {type === 'partial' && (
        <PaymentTitle type={type}>Partially Paid</PaymentTitle>
      )}
      {type === 'unpaid' && <PaymentTitle type={type}>Unpaid</PaymentTitle>}
      {type === 'paid' && <PaymentTitle type={type}>Fully Paid</PaymentTitle>}
    </PaymentPillContainer>
  )
}

export default PaymentPill
